import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'legal-cancellation-policy',
    templateUrl: './cancellation-policy.component.html',
    styleUrls: ['./cancellation-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalCancellationPolicyComponent {

	//** Input decorator */
	@Input() content!: string;
}
